import React, {useEffect} from 'react';
import {connect} from 'react-redux';
import SaleFooter from '../SaleFooter/SaleFooter';
import {
  goToPage,
  reportAnalytics,
  setFlowType,
  addProduct,
  removeProduct,
  changeProduct,
  setSelectedProductsAsync,
  reportSetSelectedProducts,
} from '../saleBlockSlice';
import {setRules} from '../rules';
import SaleProducts from '../SaleProducts/SaleProducts';

const ProductsPage = (props) => {
  let flowType = props.flowType;

  useEffect(() => {
    props.reportAnalytics({
      eventCategory: 'tv_newsale_process',
      eventAction: flowType == 'existsCustomer' ? 'visibility_7' : 'visibility_15',
      eventLabel: flowType == 'existsCustomer' ? 'screen_2a' : 'screen_3a',
    });
  }, []);

  //page params
  let isDisplayFooter = true;
  let btnText = 'להמשך';
  let currentPageFunction = handleSaleProductsPageContinue;
  let totalPrice = props.totalPrice;
  let totalPriceOneTime = props.totalPriceOneTime;
  let priceText = 'לחודש';
  let formid = 'sale';
  //page params

  let currentPageHeadline = (
    <div className='page-headline-wrapper'>
      <h1 className='sale-title'> {props.configuration.welcomeText} </h1>
      <h1 className='sale-title-big'> על כמה ממירים אנחנו מדברים? </h1>
      <h2 className='sale-title-small'> </h2>
    </div>
  );

  let currentPageView = (
    <SaleProducts
      saleType={props.saleType}
      productsInfo={props.productsInfo}
      service={props.service}
      onAddProduct={onAddProduct}
      onRemoveProduct={onRemoveProduct}
      onChangeProduct={onChangeProduct}
    />
  );

  function handleSaleProductsPageContinue() {
    props.setSelectedProductsAsync();
    props.reportSetSelectedProducts();

    if (flowType == 'existsCustomer') {
      props.goToPage({page: 'extraPage', percent: 33});
    } else {
      props.goToPage({page: 'extraPage', percent: 18});
    }
  }

  function getTotalSelectedProduct(pro) {
    let count = 0;
    props.productsInfo.products.map((productObj, index) => {
      productObj.products.map((product, key) => {
        if (product.productMakat == pro.productMakat && product.isSelected) {
          count++;
        }
      });
    });
    return count;
  }

  function onAddProduct(index) {
    let eventLabel = props.productsInfo.selectedProducts ? props.productsInfo.selectedProducts[0]?.name : '';
    props.reportAnalytics({
      eventCategory: 'tv_newsale_process',
      eventAction: 'click_20',
      eventLabel: eventLabel,
    });

    //first product is base product
    let baseProduct = props.productsInfo.baseProduct;
    if (!baseProduct) {
      return;
    }

    let count = 0;
    let products = [];
    if (index >= 1) {
      props.productsInfo.allProducts.map((data, key) => {
        let countProduct = getTotalSelectedProduct(data);

        if (countProduct < data.maximumQuantity) {
          let productWithRule = setRules(props.service.rules, data, index);
          productWithRule.index = index;
          if (productWithRule.minimumQuantity == 1) {
            productWithRule.isSelected = true;
          }
          products.push(productWithRule);
          count++;
        }
      });
    }

    if (count == 1) {
      products[0].isSelected = true;
    }

    if (count > 0) {
      props.addProduct({product: {count: count, products: products}});
    }
  }

  function onRemoveProduct(index) {
    props.removeProduct({index: index, basePrice: props.basePrice});
  }

  function onChangeProduct(index, product) {
    let countProduct = getTotalSelectedProduct(product);
    if (countProduct < product.maximumQuantity) {
      const pro = {
        index: index,
        productMakat: product.productMakat,
        productIdDelivery: product.productIdDelivery,
        additionalPrice: product.additionalPrice,
        name: product.name,
      };
      props.changeProduct({product: pro, index: index});
    }
  }

  return (
    <div className='slideAnimation'>
      {currentPageHeadline}
      <div className={'sale-page-content'}>
        {currentPageView}
        <SaleFooter
          isDisplayFooter={isDisplayFooter}
          btnText={btnText}
          onclick={currentPageFunction}
          price={totalPrice}
          totalPriceOneTime={totalPriceOneTime}
          priceText={priceText}
          formid={formid}
        />
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    saleType: state.saleBlock.saleType,
    flowType: state.saleBlock.flowType,
    page: state.saleBlock.page,
    percent: state.saleBlock.percent,
    progressBarPoints: state.saleBlock.progressBarPoints,
    configuration: state.saleBlock.epiServer.configuration,
    totalPrice: state.saleBlock.totalPrice,
    totalPriceOneTime: state.saleBlock.totalPriceOneTime,
    basePrice: state.saleBlock.epiServer.offerInfo.basePrice,
    service: state.saleBlock.epiServer.service,
    productsInfo: state.saleBlock.productsInfo,
  };
};

const mapDispatchToProps = {
  goToPage,
  reportAnalytics,
  setFlowType,
  addProduct,
  removeProduct,
  changeProduct,
  setSelectedProductsAsync,
  reportSetSelectedProducts,
};

export default connect(mapStateToProps, mapDispatchToProps)(ProductsPage);
